module.exports = __webpack_public_path__ + "static/media/blast-large.ec4578c3.png";